export const bulkActions = [
    {
        displayName: 'Download Report',
        needUserIntervention: false,
        isBulkAction: false,
        needHelperAsset: true,
        disable: false,
        callbacks: {},
    },
    {
        displayName: 'Download Error Report',
        needUserIntervention: true,
        isBulkAction: false,
        needHelperAsset: false,
        disable: false,
        callbacks: {},
    },
    {
        displayName: 'JSON Download',
        needUserIntervention: false,
        isBulkAction: true,
        needHelperAsset: false,
        disable: false,
        callbacks: {},
    },
    {
        disable: false,
        displayName: 'Run Workflow',
        isBulkAction: true,
        needHelperAsset: false,
        needUserIntervention: true,
        callbacks: {},
    },
    {
        disable: false,
        displayName: 'Associate',
        isBulkAction: true,
        needHelperAsset: true,
        needUserIntervention: false,
    },
    {
        disable: false,
        displayName: 'Download (selected)',
        isBulkAction: true,
        needHelperAsset: false,
        needUserIntervention: true,
        callbacks: {},
    },
    {
        displayName: 'Delete Processes',
        needUserIntervention: true,
        isBulkAction: true,
        needHelperAsset: false,
        disable: false,
        callbacks: {},
    },
    {
        disable: false,
        displayName: 'Audit Trails',
        isBulkAction: false,
        needHelperAsset: false,
        needUserIntervention: true,
        isInstanceLevelAction: true,
    },
    {
        disable: false,
        displayName: 'Collaborators',
        isBulkAction: false,
        needHelperAsset: false,
        needUserIntervention: true,
        isInstanceLevelAction: true,
    },
];

export const reports = [
    {
        id: '111',
        name: 'TAXILLA',
        chains: [
            {
                name: 'entransactor-Pdf',
                displayName: 'Invoice Report(PDF)',
                defaultReport: false,
                transformations: [
                    {
                        name: 'entransactor-Pdf',
                        reports: [
                            {
                                chainName: 'entransactor-Pdf',
                                reportCategory: 'ANALYTICS',
                                transformationName: 'entransactor-Pdf',
                                name: 'entransactor-Pdf',
                                reportsList: [
                                    {
                                        requestId: '6d4b96e0-f4d0-11ef-936e-8b332d5b1529',
                                        reportName: '4232.pdf',
                                        reportUrl:
                                            's3://qataxilla-mumbai/etl/v1/reports/111/2025/2/27/d561f480-f4d6-11ef-936e-8b332d5b1529/d5d4da90-f4d6-11ef-800c-4b1d04e72541/4232.pdf',
                                        chainName: 'Invoice Report(PDF)',
                                        createdOn: '2025-02-27T06:48:21+00:00',
                                        transformationName: 'entransactor-Pdf',
                                        transformationRepositoryId: '111',
                                        reportLink:
                                            'https://remote.qa.taxilla.com/mapro/process/v1/files?fileUrl=s3%3A%2F%2Fqataxilla-mumbai%2Fetl%2Fv1%2Freports%2F111%2F2025%2F2%2F27%2Fd561f480-f4d6-11ef-936e-8b332d5b1529%2Fd5d4da90-f4d6-11ef-800c-4b1d04e72541%2F4232.pdf&fileName=4232.pdf',
                                        isPrinatable: true,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                name: 'e-WayBill-Summary',
                displayName: 'Summary Report PDF',
                defaultReport: true,
                transformations: [
                    {
                        name: 'e-WayBill-Summary',
                        reports: [
                            {
                                chainName: 'e-WayBill-Summary',
                                reportCategory: 'ANALYTICS',
                                transformationName: 'e-WayBill-Summary',
                                name: 'e-WayBill-Summary',
                                reportsList: [],
                            },
                        ],
                    },
                ],
            },
            {
                name: 'ewb-html',
                displayName: 'ewb-html',
                defaultReport: false,
                transformations: [
                    {
                        name: 'ewb-html',
                        reports: [
                            {
                                chainName: 'ewb-html',
                                reportCategory: 'ANALYTICS',
                                transformationName: 'ewb-html',
                                name: 'ewb-html',
                                reportsList: [
                                    {
                                        requestId: '6d4b96e0-f4d0-11ef-936e-8b332d5b1529',
                                        reportName: 'ewb-html.html',
                                        reportUrl:
                                            's3://qataxilla-mumbai/etl/v1/reports/111/2025/2/27/ca949ad0-f4d6-11ef-936e-8b332d5b1529/cb0006d0-f4d6-11ef-800c-4b1d04e72541/ewb-html.html',
                                        chainName: 'ewb-html',
                                        createdOn: '2025-02-27T06:48:03+00:00',
                                        transformationName: 'ewb-html',
                                        transformationRepositoryId: '111',
                                        reportLink:
                                            'https://remote.qa.taxilla.com/mapro/process/v1/files?fileUrl=s3%3A%2F%2Fqataxilla-mumbai%2Fetl%2Fv1%2Freports%2F111%2F2025%2F2%2F27%2Fca949ad0-f4d6-11ef-936e-8b332d5b1529%2Fcb0006d0-f4d6-11ef-800c-4b1d04e72541%2Fewb-html.html&fileName=ewb-html.html',
                                        isPrinatable: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

export const processStatus = 'In-Progress';

export const businessKeys = [
    {
        value: 'Outward',
    },
    {
        value: 'Supply',
    },
    {
        value: 'Tax Invoice',
    },
    {
        value: 'INV001',
    },
    {
        value: '02/03/2024',
    },
];

export const businessKeysString = 'Outward|Supply|Tax Invoice|INV001|02/03/2024';

export const selectedSearchName = 'Process Status : Post-Excute E-Waybill Api Completed';

export const workflowActions = ['Process Data'];

export const currentWorkFlowStage = 'proceed';

export const assetDataId = '6d4b96e0-f4d0-11ef-936e-8b332d5b1529';

export const fieldValueMap = {
    id: '71eb9b20-9d08-11ef-9edd-d176dcc26fd9#-',
    fields: [
        {
            id: 'supply_typee',
            value: 'Inward',
            errors: [],
            warnings: [],
        },
        {
            id: 'supply_sbu_type',
            value: 'SubType1',
            errors: [],
            warnings: [],
        },
        {
            id: 'invoice_doc_type',
            value: 'Invoice',
            errors: [],
            warnings: [],
        },
        {
            id: 'inv_doc_num',
            value: 'INV12345',
            errors: [],
            warnings: [],
        },
        {
            id: 'invoice_doc_date',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'ebn_prim',
            value: 'EWB123456789',
            errors: [],
            warnings: [],
        },
        {
            id: 'api_action',
            value: 'Generate',
            errors: [],
            warnings: [],
        },
        {
            id: 'username',
            value: 'user123',
            errors: [],
            warnings: [],
        },
        {
            id: 'password',
            value: 'password123',
            errors: [],
            warnings: [],
        },
        {
            id: 'user_gstin',
            value: '05AAACG2115R1ZN',
            errors: [],
            warnings: [],
        },
        {
            id: 'auto_calc_distance',
            value: 'Yes',
            errors: [],
            warnings: [],
        },
        {
            id: 'total_val_cal',
            value: 'Yes',
            errors: [],
            warnings: [],
        },
        {
            id: 'nic_distance',
            value: 'Yes',
            errors: [],
            warnings: [],
        },
        {
            id: 'user_prod_dist',
            value: '100',
            errors: [],
            warnings: [],
        },
        {
            id: 'header_level_mismatch',
            value: 'No',
            errors: [],
            warnings: [],
        },
        {
            id: 'ewb_json',
            value: '{}',
            errors: [],
            warnings: [],
        },
        {
            id: 'ewb_response_field',
            value: 'Response123',
            errors: [],
            warnings: [],
        },
        {
            id: 'invoice_refer_number',
            value: 'IRN123',
            errors: [],
            warnings: [],
        },
        {
            id: 'ack_no',
            value: 'Ack123',
            errors: [],
            warnings: [],
        },
        {
            id: 'ack_date',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'fetch_irn_dtls',
            value: 'Yes',
            errors: [],
            warnings: [],
        },
        {
            id: 'irp_user_name',
            value: 'irpuser123',
            errors: [],
            warnings: [],
        },
        {
            id: 'irp_password',
            value: 'irppassword123',
            errors: [],
            warnings: [],
        },
        {
            id: 'irp_user_gstin',
            value: '05AAACG2115R1ZN',
            errors: [],
            warnings: [],
        },
        {
            id: 'default_distance',
            value: '0',
            errors: [],
            warnings: [],
        },
        {
            id: 'invoicetodate',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'ewaybilltodate',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'ewaybillvaliduptodate',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'hsnvalidation',
            value: 'Yes',
            errors: [],
            warnings: [],
        },
        {
            id: 'useinputdetailsforexportinvoice',
            value: 'Yes',
            errors: [],
            warnings: [],
        },
        {
            id: 'supply_type',
            value: 'Outward',
            errors: [],
            warnings: [],
        },
        {
            id: 'sub_type',
            value: 'SubType2',
            errors: [],
            warnings: [],
        },
        {
            id: 'doc_type',
            value: 'Invoice',
            errors: [],
            warnings: [],
        },
        {
            id: 'doc_no',
            value: 'DOC12345',
            errors: [],
            warnings: [],
        },
        {
            id: 'doc_date',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'transaction_type',
            value: 'Sale',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_code',
            value: 'SUP123',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_location_code',
            value: 'SUP_LOC123',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_name',
            value: 'SupplierName1',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_email',
            value: 'supplier@example.com',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_gstn',
            value: '05AAACG2115R1ZN',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_state',
            value: 'Andhra Pradesh',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_shipping_name',
            value: 'ShippingName1',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_shipping_gstn',
            value: '05AAACG2115R1ZN',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_shipping_flat',
            value: 'Flat 123',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_shipping_area',
            value: 'Area 456',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_shipping_city',
            value: 'City1',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_shipping_state',
            value: 'Andhra Pradesh',
            errors: [],
            warnings: [],
        },
        {
            id: 'supplier_shipping_pincode',
            value: '500001',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_billing_code',
            value: 'CUST123',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_billing_locationcode',
            value: 'CUST_LOC123',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_billing_name',
            value: 'CustomerName1',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_billing_email',
            value: 'customer@example.com',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_billing_gstn',
            value: '05AAACG2115R1ZN',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_billing_state',
            value: 'Andhra Pradesh',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_name',
            value: 'CustomerName2',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_city',
            value: 'City2',
            errors: [],
            warnings: [],
        },
        {
            id: 'cust_area',
            value: 'Area 789',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_flat',
            value: 'Flat 456',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_state_code',
            value: 'Andhra Pradesh',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_gstn',
            value: '05AAACG2115R1ZN',
            errors: [],
            warnings: [],
        },
        {
            id: 'customer_pincode',
            value: '500002',
            errors: [],
            warnings: [],
        },
        {
            id: 'invoicevalue',
            value: '1000.50',
            errors: [],
            warnings: [],
        },
        {
            id: 'distance_lev',
            value: '100',
            errors: [],
            warnings: [],
        },
        {
            id: 'sub_supply_desc',
            value: 'SubSupplyDesc1',
            errors: [],
            warnings: [],
        },
        {
            id: 'user_prod_distance',
            value: '50',
            errors: [],
            warnings: [],
        },
        {
            id: 'trns_mode',
            value: 'Road',
            errors: [],
            warnings: [],
        },
        {
            id: 'vehicle_number',
            value: 'TS03EE1234',
            errors: [],
            warnings: [],
        },
        {
            id: 'from_place',
            value: 'Place1',
            errors: [],
            warnings: [],
        },
        {
            id: 'vehicle_type',
            value: 'CargoType1',
            errors: [],
            warnings: [],
        },
        {
            id: 'trans_date',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'trans_dcno',
            value: 'DC12345',
            errors: [],
            warnings: [],
        },
        {
            id: 'from_state_code',
            value: 'Andhra Pradesh',
            errors: [],
            warnings: [],
        },
        {
            id: 'supp_typ',
            value: 'Outward',
            errors: [],
            warnings: [],
        },
        {
            id: 'supp_sub_type',
            value: 'SubType2',
            errors: [],
            warnings: [],
        },
        {
            id: 'inv_doc_type',
            value: 'Invoice',
            errors: [],
            warnings: [],
        },
        {
            id: 'invoice_num',
            value: 'INV12345',
            errors: [],
            warnings: [],
        },
        {
            id: 'inv_date',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'consign_status',
            value: 'InProgress',
            errors: [],
            warnings: [],
        },
        {
            id: 'transit_type',
            value: 'TransitType1',
            errors: [],
            warnings: [],
        },
        {
            id: 'from_add_1',
            value: 'Address1',
            errors: [],
            warnings: [],
        },
        {
            id: 'from_add_2',
            value: 'Address2',
            errors: [],
            warnings: [],
        },
        {
            id: 'from_add_3',
            value: 'Address3',
            errors: [],
            warnings: [],
        },
        {
            id: 'ewbconcatenationfield',
            value: 'EWB123',
            errors: [],
            warnings: [],
        },
        {
            id: 'trans_id',
            value: 'TRANS123',
            errors: [],
            warnings: [],
        },
        {
            id: 'trans_name',
            value: 'TransporterName1',
            errors: [],
            warnings: [],
        },
        {
            id: 'transporter_email',
            value: 'transporter@example.com',
            errors: [],
            warnings: [],
        },
        {
            id: 'supp_typee',
            value: 'Outward',
            errors: [],
            warnings: [],
        },
        {
            id: 'supp_sub_typ',
            value: 'SubType2',
            errors: [],
            warnings: [],
        },
        {
            id: 'inv_doc_typ',
            value: 'Invoice',
            errors: [],
            warnings: [],
        },
        {
            id: 'inv_doc_number',
            value: 'INV12345',
            errors: [],
            warnings: [],
        },
        {
            id: 'inv_doc_date',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'trans_update',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'first_name',
            value: 'John',
            errors: [],
            warnings: [],
        },
        {
            id: 'last_name',
            value: 'Doe',
            errors: [],
            warnings: [],
        },
        {
            id: 'email',
            value: 'john.doe@example.com',
            errors: [],
            warnings: [],
        },
        {
            id: 'type',
            value: 'Primary',
            errors: [],
            warnings: [],
        },
        {
            id: 'reasoncode',
            value: 'Reason1',
            errors: [],
            warnings: [],
        },
        {
            id: 'remark',
            value: 'Sample Remark',
            errors: [],
            warnings: [],
        },
        {
            id: 'from_plac',
            value: 'Place1',
            errors: [],
            warnings: [],
        },
        {
            id: 'from_stat',
            value: 'Andhra Pradesh',
            errors: [],
            warnings: [],
        },
        {
            id: 'to_plac',
            value: 'Place2',
            errors: [],
            warnings: [],
        },
        {
            id: 'to_stat',
            value: 'Telangana',
            errors: [],
            warnings: [],
        },
        {
            id: 'trans_mode',
            value: 'Road',
            errors: [],
            warnings: [],
        },
        {
            id: 'code_unit',
            value: 'Unit1',
            errors: [],
            warnings: [],
        },
        {
            id: 'total_qty',
            value: '100',
            errors: [],
            warnings: [],
        },
        {
            id: 'mul_create_date',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'group_numb',
            value: 'Group1',
            errors: [],
            warnings: [],
        },
        {
            id: 'sup_typ',
            value: 'Outward',
            errors: [],
            warnings: [],
        },
        {
            id: 'sub_ty',
            value: 'SubType2',
            errors: [],
            warnings: [],
        },
        {
            id: 'document_typ',
            value: 'Invoice',
            errors: [],
            warnings: [],
        },
        {
            id: 'doc_number',
            value: 'DOC12345',
            errors: [],
            warnings: [],
        },
        {
            id: 'document_dt',
            value: '07/11/2024',
            errors: [],
            warnings: [],
        },
        {
            id: 'transac_id',
            value: 'TRANS123',
            errors: [],
            warnings: [],
        },
        {
            id: 'init_mvm',
            value: 'Yes',
            errors: [],
            warnings: [],
        },
        {
            id: 'test',
            value: 'TestValue1',
            errors: [],
            warnings: [],
        },
        {
            id: 'test12',
            value: 'TestValue2',
            errors: [],
            warnings: [],
        },
    ],
    grids: [],
    errors: [],
    warnings: [],
};

export const tableRecord = {
    tableData: [
        {
            recordId: '722a51d0-9d08-11ef-9edd-d176dcc26fd9#-',
            errorsCount: 0,
            warningsCount: 0,
            tooltip: '',
            inAudit: false,
            isDeleted: false,
            selected: false,
            ewaybillno: '301009581676',
            ewbdate: '25/07/2024',
            genby_gstin: '05AAACG2140A1ZL',
            genby_trdname: 'TAXILLA',
            invnum: 'QA379A4352',
            invdt: '02/03/2024',
            invamt: '50101.00',
        },
        {
            recordId: '722a2ac0-9d08-11ef-9edd-d176dcc26fd9#-',
            errorsCount: 0,
            warningsCount: 0,
            tooltip: '',
            inAudit: false,
            isDeleted: false,
            selected: false,
            ewaybillno: '331009581675',
            ewbdate: '25/07/2024',
            genby_gstin: '05AAACG2140A1ZL',
            genby_trdname: 'TAXILLA',
            invnum: 'QA379A4346',
            invdt: '02/03/2024',
            invamt: '50101.00',
        },
    ],
    allColumns: [
        {
            icon: 'vpn_key',
            id: 'ewaybillno',
            name: 'E-Waybill No.',
            type: 'text',
            hide: false,
            inputType: 'STRING',
            uiTypeMetadata: 'TEXTFIELD',
        },
        {
            icon: undefined,
            id: 'ewbdate',
            name: 'E-Waybill date',
            type: 'text',
            hide: false,
            inputType: 'DATE',
            uiTypeMetadata: 'DATE',
        },
        {
            icon: undefined,
            id: 'genby_gstin',
            name: 'Generated By - GSTIN',
            type: 'text',
            hide: false,
            inputType: 'STRING',
            uiTypeMetadata: 'TEXTFIELD',
        },
        {
            icon: undefined,
            id: 'genby_trdname',
            name: 'Generated By - Trade Name',
            type: 'text',
            hide: false,
            inputType: 'STRING',
            uiTypeMetadata: 'TEXTFIELD',
        },
        {
            icon: undefined,
            id: 'invnum',
            name: 'Invoice No',
            type: 'text',
            hide: false,
            inputType: 'STRING',
            uiTypeMetadata: 'TEXTFIELD',
        },
        {
            icon: undefined,
            id: 'invdt',
            name: 'Invoice Date',
            type: 'text',
            hide: false,
            inputType: 'DATE',
            uiTypeMetadata: 'DATE',
        },
        {
            icon: undefined,
            id: 'invamt',
            name: 'Invoice Amount',
            type: 'text',
            hide: false,
            inputType: 'DOUBLE',
            uiTypeMetadata: 'TEXTFIELD',
        },
        {
            icon: undefined,
            id: 'json',
            name: 'JSON',
            type: 'text',
            hide: false,
            inputType: 'STRING',
            uiTypeMetadata: 'TEXTFIELD',
        },
        {
            icon: undefined,
            id: 'response',
            name: 'Response',
            type: 'text',
            hide: false,
            inputType: 'STRING',
            uiTypeMetadata: 'TEXTFIELD',
        },
    ],
};

export const filingAttributes = [
    {
        value: 'test777',
        values: [],
        keyId: 'orginfo^orgid',
        label: 'orgid',
        dataType: 'string',
        isPrecaptured: false,
        isBusinessKey: true,
        isSearchCriteria: false,
        entityName: 'orgid',
        displayName: 'orgid',
    },
    {
        value: '05-Mar-2025',
        values: [],
        keyId: 'orginfo^filing2',
        label: 'filing2',
        dataType: 'date',
        outputFormat: 'dd-MMM-yyyy',
        isPrecaptured: true,
        isBusinessKey: false,
        isSearchCriteria: false,
        entityName: 'filing2',
        displayName: 'filing2',
    },
    {
        value: '87546354',
        values: [],
        keyId: 'orginfo^filing1',
        label: 'filing1',
        dataType: 'string',
        isPrecaptured: true,
        isBusinessKey: false,
        isSearchCriteria: false,
        entityName: 'filing1',
        displayName: 'filing1',
    },
];

export const userUploadedFiles = [
    {
        requestId: '9a5c23b0-fe3b-11ef-8fd7-4b28ac95ae72',
        createdBy: 'taxillauser',
        createOn: '11 Mar 2025 11:12:21 AM',
        fileUri:
            's3://qataxilla-mumbai/111/attachments/E-Waybill-V12A/12/idb7d1f70b-6f0e-11ee-93a7-575e0a538a03/9a2a6550-fe3b-11ef-8fd7-4b28ac95ae72/05AAACG2115R1ZN-Demo_partition.xlsx',
        checkSum: 'afe81b6ecf2588b8e4833ac87cf3c89b96a7954e1cca3c097a4de7bbd3d2d501',
        checksumLockEnabled: true,
    },
    {
        requestId: '9a5c23b0-fe3b-11ef-8fd7-4b28ac95ae78',
        createdBy: 'taxillauser',
        createOn: '12 Mar 2025 12:10:24 AM',
        fileUri:
            's3://qataxilla-mumbai/111/attachments/E-Waybill-V12A/12/idb7d1f70b-6f0e-11ee-93a7-575e0a538a03/9a2a6550-fe3b-11ef-8fd7-4b28ac95ae72/05AAACG2115R1ZN-Demo_partition.xlsx',
        checkSum: 'afe81b6ecf2588b8e4833ac87cf3c89b96a7954e1cca3c097a4de7bbd3d2d501',
        checksumLockEnabled: true,
    },
];

export const eventTypesList = [
    {
        type: 'ASSET',
        name: 'APPLICATION_ERROR',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'APPLICATION_ERROR',
        displayName: 'Application Error',
    },
    {
        type: 'ASSET',
        name: 'APPLICATION_INFO',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'APPLICATION_INFO',
        displayName: 'Application Info',
    },
    {
        type: 'ASSET',
        name: 'APPLICATION_WARNING',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'APPLICATION_WARNING',
        displayName: 'Application Warning',
    },
    {
        type: 'ASSET',
        name: 'BULK_REPORTS_DOWNLOAD_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'BULK_REPORTS_DOWNLOAD_COMPLETED',
        displayName: 'Bulk Reports Download Completed',
    },
    {
        type: 'ASSET',
        name: 'BULK_REPORTS_DOWNLOAD_STARTED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'BULK_REPORTS_DOWNLOAD_STARTED',
        displayName: 'Bulk Reports Download Started',
    },
    {
        type: 'ASSET',
        name: 'BULK_REPORTS_DOWNLOAD_TERMINATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'BULK_REPORTS_DOWNLOAD_TERMINATED',
        displayName: 'Bulk Reports Download Terminated',
    },
    {
        type: 'ASSET',
        name: 'DOCUMENT_SHARED_WITH_PARTNER',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'DOCUMENT_SHARED_WITH_PARTNER',
        displayName: 'Document Shared With Partner',
    },
    {
        type: 'ASSET',
        name: 'DONE_FOR_NOW',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'DONE_FOR_NOW',
        displayName: 'Done For Now',
    },
    {
        type: 'ASSET',
        name: 'ETL_PROCESSING_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'ETL_PROCESSING_COMPLETED',
        displayName: 'Etl Processing Completed',
    },
    {
        type: 'ASSET',
        name: 'EVENT_TRIGGERED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'EVENT_TRIGGERED',
        displayName: 'Event Triggered',
    },
    {
        type: 'ASSET',
        name: 'INBOUND_TRANSFORMATION_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INBOUND_TRANSFORMATION_COMPLETED',
        displayName: 'Inbound Transformation Completed',
    },
    {
        type: 'ASSET',
        name: 'INBOUND_TRANSFORMATION_INFO',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INBOUND_TRANSFORMATION_INFO',
        displayName: 'Inbound Transformation Info',
    },
    {
        type: 'ASSET',
        name: 'INBOUND_TRANSFORMATION_STARTED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INBOUND_TRANSFORMATION_STARTED',
        displayName: 'Inbound Transformation Started',
    },
    {
        type: 'ASSET',
        name: 'INBOUND_TRANSFORMATION_TERMINATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INBOUND_TRANSFORMATION_TERMINATED',
        displayName: 'Inbound Transformation Terminated',
    },
    {
        type: 'ASSET',
        name: 'REQUEST_CANCELLED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'REQUEST_CANCELLED',
        displayName: 'Inbound Transmission Cancelled',
    },
    {
        type: 'ASSET',
        name: 'REQUEST_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'REQUEST_COMPLETED',
        displayName: 'Inbound Transmission Completed',
    },
    {
        type: 'ASSET',
        name: 'REQUEST_CREATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'REQUEST_CREATED',
        displayName: 'Inbound Transmission Created',
    },
    {
        type: 'ASSET',
        name: 'REQUEST_DELETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'REQUEST_DELETED',
        displayName: 'Inbound Transmission Deleted',
    },
    {
        type: 'ASSET',
        name: 'REQUEST_DONE_FOR_NOW',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'REQUEST_DONE_FOR_NOW',
        displayName: 'Inbound Transmission Done For Now',
    },
    {
        type: 'ASSET',
        name: 'REQUEST_INDEXING_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'REQUEST_INDEXING_COMPLETED',
        displayName: 'Inbound Transmission Indexing Completed',
    },
    {
        type: 'ASSET',
        name: 'REQUEST_TERMINATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'REQUEST_TERMINATED',
        displayName: 'Inbound Transmission Terminated',
    },
    {
        type: 'ASSET',
        name: 'REQUEST_VALIDATION',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'REQUEST_VALIDATION',
        displayName: 'Inbound Transmission Validation',
    },
    {
        type: 'ASSET',
        name: 'INDEXING_FAILED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INDEXING_FAILED',
        displayName: 'Indexing Failed',
    },
    {
        type: 'ASSET',
        name: 'INTEGRATION_SCHEDULER_DEACTIVATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INTEGRATION_SCHEDULER_DEACTIVATED',
        displayName: 'Integration Scheduler Deactivated',
    },
    {
        type: 'ASSET',
        name: 'MASTER_PROCESS',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'MASTER_PROCESS',
        displayName: 'Master Process',
    },
    {
        type: 'ASSET',
        name: 'OUTBOUND_INTEGRATION_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'OUTBOUND_INTEGRATION_COMPLETED',
        displayName: 'Outbound Integration Completed',
    },
    {
        type: 'ASSET',
        name: 'OUTBOUND_INTEGRATION_STARTED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'OUTBOUND_INTEGRATION_STARTED',
        displayName: 'Outbound Integration Started',
    },
    {
        type: 'ASSET',
        name: 'OUTBOUND_INTEGRATION_TERMINATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'OUTBOUND_INTEGRATION_TERMINATED',
        displayName: 'Outbound Integration Terminated',
    },
    {
        type: 'ASSET',
        name: 'OUTBOUND_TRANSFORMATION_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'OUTBOUND_TRANSFORMATION_COMPLETED',
        displayName: 'Outbound Transformation Completed',
    },
    {
        type: 'ASSET',
        name: 'OUTBOUND_TRANSFORMATION_INFO',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'OUTBOUND_TRANSFORMATION_INFO',
        displayName: 'Outbound Transformation Info',
    },
    {
        type: 'ASSET',
        name: 'OUTBOUND_TRANSFORMATION_SKIPPED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'OUTBOUND_TRANSFORMATION_SKIPPED',
        displayName: 'Outbound Transformation Skipped',
    },
    {
        type: 'ASSET',
        name: 'OUTBOUND_TRANSFORMATION_STARTED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'OUTBOUND_TRANSFORMATION_STARTED',
        displayName: 'Outbound Transformation Started',
    },
    {
        type: 'ASSET',
        name: 'OUTBOUND_TRANSFORMATION_TERMINATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'OUTBOUND_TRANSFORMATION_TERMINATED',
        displayName: 'Outbound Transformation Terminated',
    },
    {
        type: 'ASSET',
        name: 'PARTITIONING_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'PARTITIONING_COMPLETED',
        displayName: 'Partitioning Completed',
    },
    {
        type: 'ASSET',
        name: 'PARTITIONING_FAILED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'PARTITIONING_FAILED',
        displayName: 'Partitioning Failed',
    },
    {
        type: 'ASSET',
        name: 'PARTITIONING_STARTED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'PARTITIONING_STARTED',
        displayName: 'Partitioning Started',
    },
    {
        type: 'ASSET',
        name: 'PARTITIONS_CREATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'PARTITIONS_CREATED',
        displayName: 'Partitions Created',
    },
    {
        type: 'ASSET',
        name: 'PARTNER_UPDATED_DOCUMENT',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'PARTNER_UPDATED_DOCUMENT',
        displayName: 'Partner Updated Document',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_CANCELLATION_FAILED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_CANCELLATION_FAILED',
        displayName: 'Process Cancellation Failed',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_CANCELLATION_STARTED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_CANCELLATION_STARTED',
        displayName: 'Process Cancellation Started',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_CANCELLED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_CANCELLED',
        displayName: 'Process Cancelled',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_COMPLETED',
        displayName: 'Process Completed',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_CREATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_CREATED',
        displayName: 'Process Created',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_DELETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_DELETED',
        displayName: 'Process Deleted',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_DONE_FOR_NOW',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_DONE_FOR_NOW',
        displayName: 'Process Done For Now',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_INDEXING_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_INDEXING_COMPLETED',
        displayName: 'Process Indexing Completed',
    },
    {
        type: 'ASSET',
        name: 'PROCESS_LOG',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'PROCESS_LOG',
        displayName: 'Process Log',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_QUEUED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_QUEUED',
        displayName: 'Process Queued',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_TERMINATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_TERMINATED',
        displayName: 'Process Terminated',
    },
    {
        type: 'ASSET',
        name: 'INSTANCE_UPDATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCE_UPDATED',
        displayName: 'Process Updated',
    },
    {
        type: 'ASSET',
        name: 'INSTANCES_CANCELLED_INDEXED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCES_CANCELLED_INDEXED',
        displayName: 'Processes Cancelled Indexed',
    },
    {
        type: 'ASSET',
        name: 'INSTANCES_COMPLETED_INDEXED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCES_COMPLETED_INDEXED',
        displayName: 'Processes Completed Indexed',
    },
    {
        type: 'ASSET',
        name: 'INSTANCES_CREATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCES_CREATED',
        displayName: 'Processes Created',
    },
    {
        type: 'ASSET',
        name: 'INSTANCES_DONE_FOR_NOW_INDEXED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'INSTANCES_DONE_FOR_NOW_INDEXED',
        displayName: 'Processes Done For Now Indexed',
    },
    {
        type: 'ASSET',
        name: 'QUEUED_INSTANCE_INITIATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'QUEUED_INSTANCE_INITIATED',
        displayName: 'Queued Process Initiated',
    },
    {
        type: 'ASSET',
        name: 'RECORD_PROCESSED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'RECORD_PROCESSED',
        displayName: 'Record Processed',
    },
    {
        type: 'ASSET',
        name: 'SERVICE_INBOUND_REQUEST_RECEIVED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'SERVICE_INBOUND_REQUEST_RECEIVED',
        displayName: 'Service Inbound Request Received',
    },
    {
        type: 'ASSET',
        name: 'TASK_COMPLETED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'TASK_COMPLETED',
        displayName: 'Task Completed',
    },
    {
        type: 'ASSET',
        name: 'TASK_FAILED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'TASK_FAILED',
        displayName: 'Task Failed',
    },
    {
        type: 'ASSET',
        name: 'TASK_INITIATED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'TASK_INITIATED',
        displayName: 'Task Initiated',
    },
    {
        type: 'ASSET',
        name: 'TASK_STARTED',
        scope: 'CUSTOMER_PROVIDER_ORG',
        id: 'TASK_STARTED',
        displayName: 'Task Started',
    },
];

export const notificationTableData = [
    {
        createdOn: '05 Mar 2025 12:20:01 PM',
        eventType: 'Process Created',
        displayDetail:
            '<span class="d-inline-block">Process created for</span> <span class="d-inline-block"> process id</span> : 0fd786f0-f98e-11ef-bad2-c18bbec44d2a ',
        displayActions: '',
        recordId: '722a2ac0-9d08-11ef-9edd-d176dcc26fd9#-',
    },
];

export const allTableColumns = [
    {
        id: 'createdOn',
        name: 'Time',
        type: 'text',
        hide: false,
        icon: '',
    },
    {
        id: 'eventType',
        name: 'Event Type',
        type: 'text',
        hide: false,
        icon: '',
    },
    {
        id: 'displayDetail',
        name: 'Details',
        type: 'text',
        hide: false,
        icon: '',
    },
    {
        id: 'displayActions',
        name: 'Actions',
        type: 'text',
        hide: false,
        icon: '',
    },
];

export const notificationPagination = {
    count: 1,
    page: 0,
    pageIndex: 0,
    size: 10,
    searchAfter: '',
};

export const transformations = [
    {
        orgName: 'TAXILLA',
        transformations: [
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'OUT',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'IN',
                },
                sourceParts: [
                    {
                        name: 'IN',
                        sourceDataFormat: 'EXCEL',
                        fileExtension: '.xlsx',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'IN',
                id: '17416754935657118611186111111',
                displayName: 'IN',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'IN',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'OUT',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'Inbound CSV',
                },
                sourceParts: [
                    {
                        name: 'IN',
                        sourceDataFormat: 'DELIMITED',
                        fileExtension: '.csv',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        copyOf: '',
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'Inbound CSV',
                id: '17416754935657111197117886181',
                displayName: 'Inbound csv',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'Inbound csv',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'Out',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'IN TWO',
                },
                sourceParts: [
                    {
                        name: 'IN',
                        sourceDataFormat: 'EXCEL',
                        fileExtension: '.xlsx',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'IN TWO',
                id: '17416754935659619791891119117',
                displayName: 'InputFile',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'InputFile',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'out',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'inbound json',
                },
                sourceParts: [
                    {
                        name: 'in',
                        sourceDataFormat: 'JSON',
                        fileExtension: '.json',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        copyOf: '',
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'inbound json',
                id: '17416754935651181178787881181',
                displayName: 'inbound json',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'inbound json',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'Out',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'IN TWO',
                },
                sourceParts: [
                    {
                        name: 'IN',
                        sourceDataFormat: 'EXCEL',
                        fileExtension: '.xlsx',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'IN TWO',
                id: '17416754935651916619687788711',
                displayName: 'IN 1',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'IN 1',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'out',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'Inbound excel',
                },
                sourceParts: [
                    {
                        name: 'in',
                        sourceDataFormat: 'EXCEL',
                        fileExtension: '.xlsx',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        copyOf: '',
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'Inbound excel',
                id: '17416754935659198991916686119',
                displayName: 'ibound excel',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'ibound excel',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'asset',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'newInTwo',
                },
                sourceParts: [
                    {
                        name: 'excel',
                        sourceDataFormat: 'EXCEL',
                        fileExtension: '.xlsx',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'newInTwo',
                id: '17416754935651119111177979618',
                displayName: 'newInTwo',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'newInTwo',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'Asset',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'xml',
                },
                sourceParts: [
                    {
                        name: 'in',
                        sourceDataFormat: 'XML',
                        fileExtension: '.xml',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        copyOf: '',
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'xml',
                id: '17416754935651978981781897198',
                displayName: 'xml in',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'xml in',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'asset',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'newInputFile',
                },
                sourceParts: [
                    {
                        name: 'file',
                        sourceDataFormat: 'EXCEL',
                        fileExtension: '.xlsx',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'newInputFile',
                id: '17416754935651177117779811818',
                displayName: 'newInputFile',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'newInputFile',
            },
            {
                engineProps: {
                    type: 'ETL',
                    version: '2.0',
                },
                mappedTargetMetadata: {
                    name: 'Out',
                    dataFormat: 'ASSET',
                    fileExtension: '.xml',
                    targetProperties: {},
                    mappedEntities: [],
                    disableStreamBased: false,
                },
                mappingMetadata: {
                    mapName: 'IN TWO',
                },
                sourceParts: [
                    {
                        name: 'IN',
                        sourceDataFormat: 'EXCEL',
                        fileExtension: '.xlsx',
                        sourceType: 'FILE_UPLOAD',
                        sourceProperties: {},
                        useDefaultEscapeChar: true,
                        bulkUpload: false,
                        entities: [],
                        settings: {
                            scanAllChildData: false,
                        },
                    },
                ],
                name: 'IN TWO',
                id: '17416754935651111911118811611',
                displayName: 'IN two',
                xmlVersion: '5',
                isFileUpload: true,
                chainName: 'IN two',
            },
        ],
        repositoryId: '111',
    },
];

export const processLogAllColumn = [
    {
        id: 'Header',
        name: 'Header',
        type: 'text',
        hide: false,
        icon: '',
    },
    {
        id: 'Message',
        name: 'Message',
        type: 'text',
        hide: false,
        icon: '',
    },
    {
        id: 'createdOn',
        name: 'Created Time',
        type: 'text',
        hide: false,
        icon: '',
    },
];
export const assetMetaDataForClearance = {
    active: true,
    dataStreamEnabled: false,
    flushOutputData: false,
    idGenerators: [],
    masterRefMetaDatas: [],
    name: 'Recon-OutboundApp-DetachedTrue',
    displayName: 'Recon-OutboundApp-DetachedTrue',
    referredAssets: [],
    relatedAssetUids: [],
    restAPIName: 'reconoutboundappdetachedtrue',
    uid: 'idf14533f6-6509-11ef-9370-bb12ba3d5c59',
    unified: false,
    version: '1',
    entities: [
        {
            array: false,
            businessKeys: {
                fields: ['id1', 'randomnumber'],
            },
            caseSensitive: false,
            idGenerators: [],
            mandatory: false,
            displayName: 'Primary Entity',
            name: 'Primary Entity',
            primary: true,
            readOnly: false,
            show: true,
            type: 'entityMetadata',
            uid: 'primaryentity',
            entities: [],
            fields: [
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: true,
                    displayName: 'ID1',
                    name: 'ID1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_1',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'id1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: true,
                    hasLookup: false,
                    preCaptureType: 'FILING',
                    dependentForFields: [],
                    order: 1,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: true,
                    displayName: 'RandomNumber',
                    name: 'RandomNumber',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_2',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'randomnumber',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: true,
                    hasLookup: false,
                    preCaptureType: 'FILING',
                    dependentForFields: [],
                    order: 2,
                },
            ],
            rules: [],
            entityData: {
                displayName: 'Primary Entity',
                active: true,
                message: {
                    errors: [],
                    warnings: [],
                },
                fields: [
                    {
                        textDirection: 'ltr',
                        id: 'id1',
                        message: {
                            errors: [],
                            warnings: [],
                        },
                        isFromAddRecord: true,
                        displayName: 'ID1',
                        show: true,
                        isMandatory: true,
                        uiTypeMetadata: 'TEXTFIELD',
                        entityUid: 'primaryentity',
                        order: 1,
                        rules: [],
                        preCaptureType: 'FILING',
                        datatype: 'STRING',
                        masterSearchEnabled: false,
                        gridData: false,
                        showInList: false,
                        readOnly: false,
                        searchable: true,
                        sortable: false,
                        originalUiType: 'TEXTFIELD',
                        searchableIndex: 'search_string_1',
                        uiType: 'TEXTFIELD',
                        files: [],
                        dependentForFields: [],
                        autoCalculate: false,
                        tagEntries: [],
                    },
                    {
                        textDirection: 'ltr',
                        id: 'randomnumber',
                        message: {
                            errors: [],
                            warnings: [],
                        },
                        isFromAddRecord: true,
                        displayName: 'RandomNumber',
                        show: true,
                        isMandatory: true,
                        uiTypeMetadata: 'TEXTFIELD',
                        entityUid: 'primaryentity',
                        order: 2,
                        rules: [],
                        preCaptureType: 'FILING',
                        datatype: 'STRING',
                        masterSearchEnabled: false,
                        gridData: false,
                        showInList: false,
                        readOnly: false,
                        searchable: true,
                        sortable: false,
                        originalUiType: 'TEXTFIELD',
                        searchableIndex: 'search_string_2',
                        uiType: 'TEXTFIELD',
                        files: [],
                        dependentForFields: [],
                        autoCalculate: false,
                        tagEntries: [],
                    },
                ],
                entityId: 'primaryentity',
                masters: {},
                showEntity: true,
                readOnly: false,
                canAddRecord: true,
                canUpdateRecord: true,
                canDeleteRecord: true,
                businessKeysCount: 0,
                showInListCount: 0,
                preCaptureCount: 2,
                errorsCount: 0,
                warningsCount: 0,
            },
            pagination: {},
            showEntity: true,
            canAddRecord: true,
            canUpdateRecord: true,
            canDeleteRecord: true,
            hasSearchableFields: true,
            hasSortableFields: false,
        },
        {
            array: true,
            businessKeys: {
                fields: [],
            },
            caseSensitive: false,
            idGenerators: [],
            mandatory: false,
            displayName: 'Recon Data',
            name: 'Recon Data',
            primary: false,
            readOnly: false,
            show: true,
            type: 'entityMetadata',
            uid: 'recondata',
            entities: [],
            fields: [
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Step',
                    name: 'Step',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'step',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 1,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Group',
                    name: 'Group',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_3',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'group',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 2,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Score',
                    name: 'Score',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'score',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 3,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Value Matcher Response',
                    name: 'Value Matcher Response',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'valuematcherresponse',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 4,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Source',
                    name: 'Source',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'source',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 5,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Association Id',
                    name: 'Association Id',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'sort_string_1',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: true,
                    uid: 'associationid',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 6,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Source Id 1',
                    name: 'Source Id 1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'sort_string_2',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: true,
                    uid: 'sourceid1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 7,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Source Id 2',
                    name: 'Source Id 2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'sort_string_3',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: true,
                    uid: 'sourceid2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 8,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-propertyId',
                    name: 'propertyDetails-propertyId',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_4',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailspropertyid',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 9,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-transactionDate',
                    name: 'propertyDetails-transactionDate',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailstransactiondate',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 10,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-surveyNumber',
                    name: 'propertyDetails-surveyNumber',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailssurveynumber',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 11,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-registrationID',
                    name: 'propertyDetails-registrationID',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailsregistrationid',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 12,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-ifscCode',
                    name: 'propertyDetails-ifscCode',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailsifsccode',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 13,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-loanAmount',
                    name: 'propertyDetails-loanAmount',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailsloanamount',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 14,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-taxAmount',
                    name: 'propertyDetails-taxAmount',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailstaxamount',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 15,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-termsInMonths',
                    name: 'propertyDetails-termsInMonths',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailstermsinmonths',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 16,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-eligibleForLoan',
                    name: 'propertyDetails-eligibleForLoan',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailseligibleforloan',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 17,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-propertyId',
                    name: 'bankDetails-propertyId',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_5',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailspropertyid',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 18,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-transactionDate',
                    name: 'bankDetails-transactionDate',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailstransactiondate',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 19,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-surveyNumber',
                    name: 'bankDetails-surveyNumber',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailssurveynumber',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 20,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-registrationID',
                    name: 'bankDetails-registrationID',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailsregistrationid',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 21,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-ifscCode',
                    name: 'bankDetails-ifscCode',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailsifsccode',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 22,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-loanAmount',
                    name: 'bankDetails-loanAmount',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailsloanamount',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 23,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-termsInMonths',
                    name: 'bankDetails-termsInMonths',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailstermsinmonths',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 24,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-taxAmount',
                    name: 'bankDetails-taxAmount',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailstaxamount',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 25,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-eligibleForLoan',
                    name: 'bankDetails-eligibleForLoan',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailseligibleforloan',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 26,
                },
            ],
            rules: [],
            entityData: [],
            pagination: {},
            showEntity: true,
            canAddRecord: true,
            canUpdateRecord: true,
            canDeleteRecord: true,
            hasSearchableFields: true,
            hasSortableFields: true,
        },
        {
            array: true,
            businessKeys: {
                fields: [],
            },
            caseSensitive: false,
            idGenerators: [],
            mandatory: false,
            displayName: 'Recon Data_source1',
            name: 'Recon Data_source1',
            primary: false,
            readOnly: false,
            show: true,
            type: 'entityMetadata',
            uid: 'recondata_source1',
            entities: [],
            fields: [
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Step_source1',
                    name: 'Step_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'step_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 1,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Group_source1',
                    name: 'Group_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_6',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'group_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 2,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Score_source1',
                    name: 'Score_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'score_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 3,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Value Matcher Response_source1',
                    name: 'Value Matcher Response_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'valuematcherresponse_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 4,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Source_source1',
                    name: 'Source_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'source_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 5,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Source Id 1_source1',
                    name: 'Source Id 1_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_7',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'sourceid1_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 7,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-propertyId_source1',
                    name: 'propertyDetails-propertyId_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_8',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailspropertyid_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 8,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-transactionDate_source1',
                    name: 'propertyDetails-transactionDate_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailstransactiondate_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 9,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-surveyNumber-source1',
                    name: 'propertyDetails-surveyNumber-source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailssurveynumbersource1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 10,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-registrationID-source1',
                    name: 'propertyDetails-registrationID-source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailsregistrationidsource1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 11,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-ifscCode-source1',
                    name: 'propertyDetails-ifscCode-source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailsifsccodesource1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 12,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-loanAmount-source1',
                    name: 'propertyDetails-loanAmount-source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailsloanamountsource1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 13,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-taxAmount-source1',
                    name: 'propertyDetails-taxAmount-source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailstaxamountsource1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 14,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-termsInMonths-source1',
                    name: 'propertyDetails-termsInMonths-source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailstermsinmonthssource1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 15,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'propertyDetails-eligibleForLoan_source1',
                    name: 'propertyDetails-eligibleForLoan_source1',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'propertydetailseligibleforloan_source1',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'propertyDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 16,
                },
            ],
            rules: [],
            entityData: [],
            pagination: {},
            showEntity: true,
            canAddRecord: true,
            canUpdateRecord: true,
            canDeleteRecord: true,
            hasSearchableFields: true,
            hasSortableFields: false,
        },
        {
            array: true,
            businessKeys: {
                fields: [],
            },
            caseSensitive: false,
            idGenerators: [],
            mandatory: false,
            displayName: 'Recon Data_source2',
            name: 'Recon Data_source2',
            primary: false,
            readOnly: false,
            show: true,
            type: 'entityMetadata',
            uid: 'recondata_source2',
            entities: [],
            fields: [
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Step_source2',
                    name: 'Step_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'step_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 1,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Group_source2',
                    name: 'Group_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_9',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'group_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 2,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Score_source2',
                    name: 'Score_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'score_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 3,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Value Matcher Response_source2',
                    name: 'Value Matcher Response_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'valuematcherresponse_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 4,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Source_source2',
                    name: 'Source_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'source_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 5,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'Source Id 2_source2',
                    name: 'Source Id 2_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_10',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'sourceid2_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 7,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-propertyId_source2',
                    name: 'bankDetails-propertyId_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: true,
                    searchableIndex: 'search_string_11',
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailspropertyid_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 8,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-transactionDate_source2',
                    name: 'bankDetails-transactionDate_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailstransactiondate_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 9,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-surveyNumber-source2',
                    name: 'bankDetails-surveyNumber-source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailssurveynumbersource2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 10,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-registrationID_source2',
                    name: 'bankDetails-registrationID_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailsregistrationid_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 11,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-ifscCode_source2',
                    name: 'bankDetails-ifscCode_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailsifsccode_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 12,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-loanAmount_source2',
                    name: 'bankDetails-loanAmount_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailsloanamount_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 13,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-termsInMonths_source2',
                    name: 'bankDetails-termsInMonths_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailstermsinmonths_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 14,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-taxAmount_source2',
                    name: 'bankDetails-taxAmount_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailstaxamount_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 15,
                },
                {
                    allowBulkUpdate: true,
                    captureOnce: false,
                    datatype: 'STRING',
                    mandatory: false,
                    displayName: 'bankDetails-eligibleForLoan_source2',
                    name: 'bankDetails-eligibleForLoan_source2',
                    readOnly: false,
                    relatedFields: [],
                    ruleReferences: [],
                    searchable: false,
                    show: true,
                    showInList: false,
                    showInMap: true,
                    sortable: false,
                    uid: 'bankdetailseligibleforloan_source2',
                    uiTypeMetadata: 'TEXTFIELD',
                    masterData: {},
                    fieldSection: 'bankDetails',
                    autoCalculate: false,
                    tagEntries: [],
                    rules: [],
                    isBusinessKey: false,
                    hasLookup: false,
                    dependentForFields: [],
                    order: 16,
                },
            ],
            rules: [],
            entityData: [],
            pagination: {},
            showEntity: true,
            canAddRecord: true,
            canUpdateRecord: true,
            canDeleteRecord: true,
            hasSearchableFields: true,
            hasSortableFields: false,
        },
    ],
    lookups: [],
    rules: [],
    tagEntries: [
        {
            key: 'detached-source2',
            value: 'recondata_source2',
        },
        {
            key: 'detached-source1',
            value: 'recondata_source1',
        },
        {
            key: 'unique-id-source-1',
            value: 'sourceid1',
        },
        {
            key: 'unique-id-source-2',
            value: 'sourceid2',
        },
        {
            key: 'reconcile-output',
            value: 'propertybankrecononeonetrue',
        },
        {
            key: 'group-name-field-id',
            value: 'group',
        },
        {
            key: 'association-id',
            value: 'associationid',
        },
        {
            key: 'package',
            value: 'closures',
        },
        {
            key: 'group-order',
            value: 'clearance--1',
        },
        {
            key: 'output-source-1',
            value: 'propertyDetails',
        },
        {
            key: 'output-source-2',
            value: 'bankDetails',
        },
        {
            key: 'app-order',
            value: 'order--1',
        },
    ],
    workflowMetadata: {
        customizable: true,
        id: 'idf14533f6-6509-11ef-9370-bb12ba3d5c59',
        originalName: 'Recon-OutboundApp-DetachedTrue',
        name: 'Recon-OutboundApp-DetachedTrue',
        status: 'NEW',
        version: '2',
        stages: [
            {
                category: 'DELTA_CAPTURE',
                emailEnabled: false,
                id: 'deltaCapture19',
                originalName: 'Transfer Selected Records',
                name: 'Transfer Selected Records',
                displayName: 'Transfer Selected Records',
                nodePosition: {
                    nodePositionLeft: 15,
                    nodePositionTop: 304,
                },
                order: 5,
                skippable: false,
                stageTransitions: [],
                userTask: true,
                userActions: [
                    {
                        defaultAction: true,
                        originalName: 'Transfer Selected Records',
                        name: 'Transfer Selected Records',
                        displayName: 'Transfer Selected Records',
                        nextStageId: 'rulesExecution141',
                        nextStageName: 'Rules Execution',
                        commentEnabled: true,
                        expression: '',
                        message: '',
                        formFields: [],
                    },
                ],
            },
            {
                category: 'START',
                emailEnabled: true,
                id: 'start',
                originalName: 'Start',
                name: 'Start',
                displayName: 'Start',
                nodePosition: {
                    nodePositionLeft: 15,
                    nodePositionTop: 20,
                },
                order: 0,
                skippable: false,
                stageTransitions: [],
                userTask: true,
                userActions: [
                    {
                        defaultAction: true,
                        originalName: 'Proceed',
                        name: 'Proceed',
                        displayName: 'Proceed',
                        nextStageId: 'dataSynchronization9410',
                        nextStageName: 'Data Synchronization',
                        commentEnabled: false,
                        message: '',
                        formFields: [],
                    },
                ],
            },
            {
                category: 'DATA_SYNCHRONIZATION',
                emailEnabled: true,
                id: 'dataSynchronization9410',
                originalName: 'Data Synchronization',
                name: 'Data Synchronization',
                displayName: 'Data Synchronization',
                nodePosition: {
                    nodePositionLeft: 187,
                    nodePositionTop: 22,
                },
                order: 1,
                skippable: false,
                stageTransitions: [],
                userTask: true,
                userActions: [
                    {
                        defaultAction: true,
                        originalName: 'Proceed',
                        name: 'Proceed',
                        displayName: 'Proceed',
                        nextStageId: 'custom15',
                        nextStageName: 'Selected Record Deletion',
                        commentEnabled: true,
                        expression: '',
                        message: '',
                        formFields: [],
                    },
                ],
            },
            {
                category: 'RULES_EXECUTION',
                emailEnabled: true,
                id: 'rulesExecution141',
                originalName: 'Rules Execution',
                name: 'Rules Execution',
                displayName: 'Rules Execution',
                nodePosition: {
                    nodePositionLeft: 70,
                    nodePositionTop: 359,
                },
                order: 6,
                ruleBean: {
                    beanName: 'rulesExecutionTask',
                    beanMethod: 'executeRules',
                },
                skippable: false,
                stageTransitions: [
                    {
                        expression: "getStageVariable('allRulesPassed') == true",
                        nextStageId: 'reviewApproval123',
                        message: 'Rules Execution successful',
                    },
                    {
                        expression: "getStageVariable('allRulesPassed') == false",
                        nextStageId: 'custom15',
                        message: 'Rules Execution failure',
                    },
                ],
                userTask: false,
                userActions: [],
            },
            {
                category: 'REVIEW_APPROVAL',
                emailEnabled: true,
                id: 'reviewApproval123',
                originalName: 'Data Submission',
                name: 'Data Submission',
                displayName: 'Data Submission',
                nodePosition: {
                    nodePositionLeft: 730,
                    nodePositionTop: 517,
                },
                order: 7,
                skippable: false,
                stageTransitions: [],
                userTask: true,
                userActions: [
                    {
                        defaultAction: true,
                        originalName: 'Generate Reports',
                        name: 'Generate Reports',
                        displayName: 'Generate Reports',
                        nextStageId: 'reportsGeneration1075',
                        nextStageName: 'Reports Generation',
                        commentEnabled: false,
                        message: 'Data Submission successful',
                        formFields: [],
                    },
                    {
                        defaultAction: false,
                        originalName: 'Edit Data',
                        name: 'Edit Data',
                        displayName: 'Edit Data',
                        nextStageId: 'custom15',
                        nextStageName: 'Selected Record Deletion',
                        commentEnabled: false,
                        expression: '',
                        message: '',
                        formFields: [],
                    },
                ],
            },
            {
                category: 'REPORTS_GENERATION',
                emailEnabled: true,
                id: 'reportsGeneration1075',
                originalName: 'Reports Generation',
                name: 'Reports Generation',
                displayName: 'Reports Generation',
                nodePosition: {
                    nodePositionLeft: 1297,
                    nodePositionTop: 437,
                },
                order: 8,
                ruleBean: {
                    beanName: 'reportsGenerationTask',
                    beanMethod: 'generateReports',
                },
                skippable: false,
                stageTransitions: [
                    {
                        expression: "getStageVariable('reportsGenerated') == true",
                        nextStageId: 'end',
                        message: 'Reports Generation successful',
                    },
                ],
                userTask: false,
                userActions: [],
            },
            {
                category: 'END',
                emailEnabled: true,
                id: 'end',
                originalName: 'End',
                name: 'End',
                displayName: 'End',
                nodePosition: {
                    nodePositionLeft: 1824,
                    nodePositionTop: 370,
                },
                order: 0,
                skippable: false,
                userTask: true,
                userActions: [],
            },
            {
                category: 'CUSTOM',
                emailEnabled: false,
                id: 'custom15',
                originalName: 'Selected Record Deletion',
                name: 'Selected Record Deletion',
                displayName: 'Selected Record Deletion',
                nodePosition: {
                    nodePositionLeft: 808,
                    nodePositionTop: 49,
                },
                order: 2,
                skippable: false,
                stageTransitions: [],
                userTask: true,
                userActions: [
                    {
                        defaultAction: true,
                        originalName: 'Delete Selected Records',
                        name: 'Delete Selected Records',
                        displayName: 'Delete Selected Records',
                        nextStageId: 'custom16',
                        nextStageName: 'Condition-Based Record Deletion',
                        commentEnabled: true,
                        expression: '',
                        message: '',
                        formFields: [],
                    },
                ],
            },
            {
                category: 'CUSTOM',
                emailEnabled: false,
                id: 'custom16',
                originalName: 'Condition-Based Record Deletion',
                name: 'Condition-Based Record Deletion',
                displayName: 'Condition-Based Record Deletion',
                nodePosition: {
                    nodePositionLeft: 1347,
                    nodePositionTop: 185,
                },
                order: 3,
                skippable: false,
                stageTransitions: [],
                userTask: true,
                userActions: [
                    {
                        defaultAction: true,
                        originalName: 'Condition Based Record Deletion',
                        name: 'Condition Based Record Deletion',
                        displayName: 'Condition Based Record Deletion',
                        nextStageId: 'deltaCapture22',
                        nextStageName: 'Selected Record Update',
                        commentEnabled: true,
                        expression: '',
                        message: '',
                        formFields: [],
                    },
                ],
            },
            {
                category: 'DELTA_CAPTURE',
                emailEnabled: false,
                id: 'deltaCapture22',
                originalName: 'Selected Record Update',
                name: 'Selected Record Update',
                displayName: 'Selected Record Update',
                nodePosition: {
                    nodePositionLeft: 1137,
                    nodePositionTop: 286,
                },
                order: 4,
                skippable: false,
                stageTransitions: [],
                userTask: true,
                userActions: [
                    {
                        defaultAction: true,
                        originalName: 'Selected Record Update',
                        name: 'Selected Record Update',
                        displayName: 'Selected Record Update',
                        nextStageId: 'deltaCapture19',
                        nextStageName: 'Transfer Selected Records',
                        commentEnabled: true,
                        expression: '',
                        message: '',
                        formFields: [],
                    },
                ],
            },
        ],
    },
    workflowStageReferences: [],
    computationalRules: {},
    templateUpdated: true,
};

export const reconConfig = {
    repository: '111',
    restapiname: 'propertybankrecononeonetrue',
    version: 2,
    name: 'propertybankrecononeonetrue',
    sources: [
        {
            id: 'propertyDetails',
            name: 'Property Details',
            fields: [
                {
                    id: 'propertyId',
                    name: 'Property Id',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'transactionDate',
                    name: 'Transaction Date',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'surveyNumber',
                    name: 'Survey No',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'registrationID',
                    name: 'Registration Id',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'loanAmount',
                    name: 'Loan Amount',
                    type: 'FLOAT',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'taxAmount',
                    name: 'Tax Amount',
                    type: 'FLOAT',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'eligibleForLoan',
                    name: 'Loan Eligibility',
                    type: 'BOOLEAN',
                    fields: [],
                    key: false,
                    mandatory: true,
                    eventTime: false,
                },
                {
                    id: 'termsInMonths',
                    name: 'Terms in Months',
                    type: 'INTEGER',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'ifscCode',
                    name: 'IFSC Code',
                    type: 'STRING',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
            ],
            preprocessKeySelector: null,
            preprocessor: null,
            keyFields: [
                {
                    id: 'propertyId',
                    name: 'Property Id',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'transactionDate',
                    name: 'Transaction Date',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'surveyNumber',
                    name: 'Survey No',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'registrationID',
                    name: 'Registration Id',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
            ],
        },
        {
            id: 'bankDetails',
            name: 'Bank Details',
            fields: [
                {
                    id: 'propertyId',
                    name: 'Property Id',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'transactionDate',
                    name: 'Transaction Date',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'surveyNumber',
                    name: 'Survey No',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'registrationID',
                    name: 'Registration Id',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'loanAmount',
                    name: 'Loan Amount',
                    type: 'FLOAT',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'termsInMonths',
                    name: 'Terms in Months',
                    type: 'INTEGER',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'ifscCode',
                    name: 'IFSC Code',
                    type: 'STRING',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'taxAmount',
                    name: 'Tax Amount',
                    type: 'FLOAT',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'eligibleForLoan',
                    name: 'Loan Eligibility',
                    type: 'BOOLEAN',
                    fields: [],
                    key: false,
                    mandatory: false,
                    eventTime: false,
                },
            ],
            preprocessKeySelector: null,
            preprocessor: null,
            keyFields: [
                {
                    id: 'propertyId',
                    name: 'Property Id',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'transactionDate',
                    name: 'Transaction Date',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'surveyNumber',
                    name: 'Survey No',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
                {
                    id: 'registrationID',
                    name: 'Registration Id',
                    type: 'STRING',
                    fields: [],
                    key: true,
                    mandatory: false,
                    eventTime: false,
                },
            ],
        },
    ],
    requestParameters: [
        {
            id: 'taxTolerance',
            name: 'Tax amount deviation tolerance (in %)',
            description: 'Tax amount deviation tolerance (in %)',
            type: 'FLOAT',
            mandatory: false,
            defaultValue: 20,
        },
    ],
    cardinality: 'ONE_TO_ONE',
    groups: [
        {
            id: 'match',
            name: 'Keys match - Value match/mismatch',
            description: 'Keys match - Value match/mismatch',
            detached: false,
        },
        {
            id: 'probable-match1',
            name: 'Keys match - Value matches with tolerance',
            description: 'Keys match - Value matches with tolerance',
            detached: false,
        },
        {
            id: 'probable-match2',
            name: 'Property Id partially Match - Values match or mismatch',
            description: 'Property Id partially Match - Values match or mismatch',
            detached: false,
        },
        {
            id: 'probable-match3',
            name: 'Registration Id partially match - Values match or mismatch',
            description: 'Registration Id partially match - Values match or mismatch',
            detached: false,
        },
        {
            id: 'mismatch',
            name: 'Mismatch',
            description: 'Mismatch',
            detached: true,
        },
    ],
    defaultGroup: 'mismatch',
    mismatchGroup: 'mismatch',
    steps: [
        {
            index: 0,
            id: 'step_0',
            name: 'Match By Property Id, Survey No, Tx Date & Registration Id',
            description: 'Match By Property Id, Survey No, Tx Date & Registration Id',
            mandatory: false,
            group: 'match',
            singleSource: false,
            source: '',
            keyMatcherFunctions: {},
            keySelectorFunctions: {
                propertyDetails: {
                    functionScript:
                        '[propertyDetailsKey.propertyId, stringToDate(propertyDetailsKey.transactionDate), propertyDetailsKey.surveyNumber, propertyDetailsKey.registrationID]',
                },
                bankDetails: {
                    functionScript:
                        '[bankDetailsKey.propertyId, stringToDate(bankDetailsKey.transactionDate), bankDetailsKey.surveyNumber, bankDetailsKey.registrationID]',
                },
            },
            valueMatcher: {
                grouped: false,
                filterEmptySet: true,
                functionScript:
                    'if (propertyDetails.loanAmount != bankDetails.loanAmount) {\n    if (((Double)Math.abs((Integer) propertyDetails.taxAmount - (Integer) bankDetails.taxAmount)) / propertyDetails.taxAmount <= (requestParams.taxTolerance / 100)) {\n        result.group("probable-match1")\n        result.collect([property:"taxAmount", message: "Tax amounts " + propertyDetails.taxAmount + " and " + bankDetails.taxAmount + " match with " + requestParams.taxTolerance + "% tolerance", match: true])\n    } else {\n        result.collect([property:"taxAmount", message: "Tax amounts " + propertyDetails.taxAmount + " and " + bankDetails.taxAmount + " do not match", match: false])\n        result.score(0)\n    }\n}\nif (propertyDetails.taxAmount != bankDetails.taxAmount) {\n    result.collect([property:"taxAmount", message: "Tax amounts " + propertyDetails.taxAmount + " and " + bankDetails.taxAmount + " do not match", match: false])\n    result.score(0)\n}\nif (propertyDetails.termsInMonths != bankDetails.termsInMonths) {\n    result.collect([property:"termsInMonths", message: "Terms in month " + propertyDetails.termsInMonths + " and " + bankDetails.termsInMonths + " do not match", match: false])\n    result.score(0)\n}',
            },
            useSimilarityMatch: false,
            sourceOneKey: null,
            sourceTwoKey: null,
        },
        {
            index: 1,
            id: 'step_1',
            name: 'Partial match by Property Id',
            description: 'Partial match by Property Id',
            mandatory: false,
            group: 'probable-match2',
            singleSource: false,
            source: '',
            keyMatcherFunctions: {},
            keySelectorFunctions: {
                propertyDetails: {
                    functionScript:
                        '[trimPropertyId(propertyDetailsKey.propertyId), stringToDate(propertyDetailsKey.transactionDate), trimSurveyNo(propertyDetailsKey.surveyNumber), propertyDetailsKey.registrationID]',
                },
                bankDetails: {
                    functionScript:
                        '[trimPropertyId(bankDetailsKey.propertyId), stringToDate(bankDetailsKey.transactionDate), trimSurveyNo(bankDetailsKey.surveyNumber), bankDetailsKey.registrationID]',
                },
            },
            valueMatcher: {
                grouped: false,
                filterEmptySet: true,
                functionScript: 'matchValues(propertyDetails, bankDetails, result)',
            },
            useSimilarityMatch: false,
            sourceOneKey: null,
            sourceTwoKey: null,
        },
        {
            index: 2,
            id: 'step_2',
            name: 'Partial match by Registration Id',
            description: 'Partial match by Registration Id',
            mandatory: false,
            group: 'probable-match3',
            singleSource: false,
            source: '',
            keyMatcherFunctions: {},
            keySelectorFunctions: {
                propertyDetails: {
                    functionScript:
                        '[propertyDetailsKey.propertyId, stringToDate(propertyDetailsKey.transactionDate), propertyDetailsKey.surveyNumber, trimRegistrationId(propertyDetailsKey.registrationID)]',
                },
                bankDetails: {
                    functionScript:
                        '[bankDetailsKey.propertyId, stringToDate(bankDetailsKey.transactionDate), bankDetailsKey.surveyNumber, trimRegistrationId(bankDetailsKey.registrationID)]',
                },
            },
            valueMatcher: {
                grouped: false,
                filterEmptySet: true,
                functionScript: 'matchValues(propertyDetails, bankDetails, result)',
            },
            useSimilarityMatch: false,
            sourceOneKey: null,
            sourceTwoKey: null,
        },
    ],
    commonFunctions: [
        'private matchValues(propertyDetails, bankDetails, result) {\n    if (propertyDetails.loanAmount != bankDetails.loanAmount) {\n        result.collect([property:"loanAmount", message: "Loan amounts " + propertyDetails.loanAmount + " and " + bankDetails.loanAmount + " do not match", match: false])\n        result.score(0)                \n    }\n    if (propertyDetails.taxAmount != bankDetails.taxAmount) {\n        result.collect([property:"taxAmount", message: "Tax amounts " + propertyDetails.taxAmount + " and " + bankDetails.taxAmount + " do not match", match: false])\n        result.score(0)\n    }\n    if (propertyDetails.termsInMonths != bankDetails.termsInMonths) {\n        result.collect([property:"termsInMonths", message: "Terms in month " + propertyDetails.termsInMonths + " and " + bankDetails.termsInMonths + " do not match", match: false])\n        result.score(0)\n    }\n}\n\nprivate Date stringToDate(String dateStr) {\n    try {\n        dateStr = dateStr.trim()\n        if (dateStr.charAt(2) == \'/\' && dateStr.charAt(5) == \'/\' && dateStr.length() == 10) {\n            return Date.parse(\'dd/MM/yyyy\', dateStr)\n        } else if (dateStr.charAt(2) == \'-\' && dateStr.charAt(5) == \'-\' && dateStr.length() == 10) {\n            return Date.parse(\'dd-MM-yyyy\', dateStr)\n        } else if (dateStr.charAt(4) == \'/\' && dateStr.charAt(7) == \'/\' && dateStr.length() == 10) {\n            return Date.parse(\'yyyy/MM/dd\', dateStr)\n        }\n    } catch (Exception e) {\n    }\n    throw new RuntimeException("Invalid date " + dateStr)\n}\n\nString trimPropertyId(String propertyId) {\n    if (!propertyId.contains("_")) {\n        return propertyId\n    }\n    String[] splits = propertyId.split("_")\n    return splits.drop(splits.length - 2).join("")\n}\n\nString trimSurveyNo(String surveyNo) {\n    if (surveyNo.startsWith(\'SID\'))\n        return surveyNo.replaceFirst(\'SID\', \'SN#\')\n    return surveyNo\n}\n\nString trimRegistrationId(String regId) {\n    if (regId.startsWith(\'RGID\'))\n        return regId.replaceFirst(\'RGID\', \'Reg-\')\n    return regId\n}',
    ],
    useOffHeapMemory: false,
    metadataId: 'propertybankrecononeonetrue_2',
};
